import { render, staticRenderFns } from "./fileDataMoon.vue?vue&type=template&id=5aba6c07&scoped=true&"
import script from "./fileDataMoon.vue?vue&type=script&lang=js&"
export * from "./fileDataMoon.vue?vue&type=script&lang=js&"
import style0 from "./fileDataMoon.vue?vue&type=style&index=0&id=5aba6c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba6c07",
  null
  
)

export default component.exports